import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { RelatorioNpsListWrapper } from './relatorio-nps-list/RelatorioNpsList'

const RelatorioNpsPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('pagina.relatorioNps.descricao')}>Relatório NPS</PageTitle>
            <RelatorioNpsListWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default RelatorioNpsPage
